<template>
  <div class="user_info_container_content">
    <div class="title_top_hr">
      <p>
        <i></i>
        <span>实名认证</span>
      </p>
      <el-divider></el-divider>
    </div>
    <div class="certification_box"
    v-loading="authenticationLoading"
    element-loading-text="认证信息加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(256, 256, 256, 0.8)">
      <el-steps class="user_authentication_step" :active="stepActive" :process-status="processStatus" finish-status="success">
        <el-step title="填写信息"></el-step>
        <el-step title="审核状态"></el-step>
        <el-step title="审核结果"></el-step>
      </el-steps>
      <!-- 未审核 -->
      <el-form  v-if="examine.type === 0" :model="info" ref="formData" :rules="rule" label-width="80px">
        <el-form-item label="真实姓名" prop="card_id_name">
          <el-input v-model="info.card_id_name"></el-input>
        </el-form-item>
        <el-form-item label="身份证号" prop="card_id">
          <el-input v-model="info.card_id"></el-input>
        </el-form-item>
        <el-form-item label="证件照片" :required='true'>
          <dl>
            <dt>
              <imgUpload :filestype="img.frontType" :imgurl="info.front_card_id" :imgtext="img.forntText" @files="files"></imgUpload>
            </dt>
            <dd>
              <imgUpload :filestype="img.reverseType" :imgurl="info.reverse_card_id" :imgtext="img.reverseText" @files="files"></imgUpload>
            </dd>
          </dl>
        </el-form-item>
        <el-form-item>
          <div class="rg_form_box_form_item" v-show="!textOnOff">
            <el-button v-show="subBtnOnOff" type="primary" class="rg_form_box_form_sub" @click="submitForm('formData')">提交</el-button>
            <el-button v-show="!subBtnOnOff" type="primary" :loading="true">提交中</el-button>
          </div>
        </el-form-item>
      </el-form>
      <!-- 审核中 -->
      <div v-if="examine.type === 1" class="user_review_box">
        <img src="../../assets/img/authentication/personalReview.png" alt="审核中">
        <dl class="user_review_tip">
          <dt>您提交的身份信息正在审核中...</dt>
          <dd>
            <p>预计一个工作日内完成审核，请耐心等待！</p>
          </dd>
        </dl>
      </div>
      <!-- 审核成功 -->
      <div v-if="examine.type === 2" class="user_review_box">
        <img src="../../assets/img/authentication/personalReviewSuccess.png" alt="认证通过">
        <dl class="user_review_tip">
          <dt>认证通过！</dt>
          <dd>
            <p class="user_review_name">
              {{info.card_id_name}}
            </p>
            <p>
              {{numFilter(info.card_id)}}
            </p>
          </dd>
        </dl>
      </div>
      <!-- 审核失败 -->
      <div v-if="examine.type === 3" class="user_review_box">
        <img src="../../assets/img/authentication/personalReviewError.png" alt="认证失败">
        <dl class="user_review_tip">
          <dt>您的实名认证未通过审核！</dt>
          <dd>
            <p class="user_review_name">
              拒绝原因：{{examine.text}}
            </p>
          </dd>
        </dl>
        <button class="my_follow_btn user_review_btn" @click="resetClick()">重新认证</button>
      </div>
    </div>
  </div>
</template>

<script>
import img from '../Public/imgUpload.vue'
export default {
  components: {
    imgUpload: img
  },
  data () {
    return {
      authenticationLoading: true, // 认证加载动画
      stepActive: 0, // 步骤条当前显示步骤
      processStatus: '', // 当前步骤的状态
      subBtnOnOff: true, // 提交状态
      textOnOff: false, // 是否显示输入框
      examine: { // 审核状态
        type: 0,
        text: ''
      },
      info: {
        type: 1,
        card_id_name: '',
        card_id: '',
        front_card_id: '', // 正面
        reverse_card_id: '' // 反面
      },
      img: {
        arr: [],
        frontType: 'front',
        reverseType: 'reverse',
        forntText: '请您上传申请人身份证人像面照片，请确保证件在有效期限内，每张图片大小不超过 2M。',
        reverseText: '请您上传申请人身份证国徽面照片，请确保证件在有效期限内，每张图片大小不超过 2M。'
      },
      rule: {
        card_id_name: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
          { min: 2, max: 10, message: '长度在 2 到 10 个字符', trigger: 'blur' },
          {
            required: true,
            pattern: /^[\u4e00-\u9fa5_a-zA-Z0-9.·-]+$/,
            message: '姓名不支持特殊字符',
            trigger: 'blur'
          }
        ],
        card_id: [
          { required: true, message: '请输入身份证号', trigger: 'blur' },
          { min: 15, max: 18, message: '请如实填写18位号码', trigger: 'change' },
          {
            required: true,
            pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
            message: '请输入正确的身份证号码',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  created () {
    this.getAuthenticationLog()
  },
  methods: {
    // 获取认证信息
    getAuthenticationLog () {
      const vueThat = this
      vueThat.myApi.getAuthenticationLog({ type: vueThat.info.type }).then((res) => {
        if (res.data.code === 200) {
          vueThat.authenticationLoading = false
          vueThat.stepActive = res.data.data.is_auth
          if (res.data.data.is_auth === 0) { // 未进行认证
            vueThat.processStatus = 'finish'
          } else {
            vueThat.examine.type = res.data.data.is_auth
            for (const key in res.data.data.data) {
              vueThat.info[key] = res.data.data.data[key]
            }
            vueThat.img.arr = [vueThat.info.front_card_id, vueThat.info.reverse_card_id]
            if (res.data.data.is_auth === 1 || res.data.data.is_auth === 2) { // 审核中 和 审核成功
              if (res.data.data.is_auth === 1) {
                vueThat.stepActive = 1
                vueThat.processStatus = 'finish'
              } else {
                vueThat.stepActive = 2
                vueThat.processStatus = 'success'
              }
            } else { // 审核失败
              vueThat.stepActive = 2
              vueThat.processStatus = 'error'
              vueThat.examine.text = res.data.data.reason
            }
          }
        }
      })
    },
    files (url, type, proofImage) {
      switch (type) {
        case 'front':
          this.info.front_card_id = url
          break
        case 'reverse':
          this.info.reverse_card_id = url
          break
      }
    },
    submitForm (formName) {
      const vueThat = this
      vueThat.$refs[formName].validate((valid) => {
        if (valid) {
          if (vueThat.info.front_card_id === '') {
            vueThat.$message.error('请上传身份证正面照！')
          } else if (vueThat.info.reverse_card_id === '') {
            vueThat.$message.error('请上传身份证反面照！')
          } else {
            vueThat.subBtnOnOff = false
            vueThat.myApi.userRealNameAuthentication(vueThat.info).then((res) => {
              if (res.data.code === 200) {
                vueThat.subBtnOnOff = true
                vueThat.$alert('提交成功，请等待审核...', '温馨提示', {
                  type: 'success',
                  iconClass: 'iconfont icon-icon_richeng_btn_pass',
                  confirmButtonText: '确定',
                  showClose: false,
                  callback: action => {
                    vueThat.examine.type = 1
                    vueThat.stepActive = 1
                    vueThat.processStatus = 'finish'
                  }
                })
              } else {
                vueThat.subBtnOnOff = true
              }
            })
          }
        } else {
          vueThat.$message.error('请检查填写项是否正确！')
          return false
        }
      })
    },
    // 身份证号过滤
    numFilter (num) {
      const str = num.substring(10, 15)
      return num.replace(str, '****')
    },
    // 重置信息提交申请
    resetClick () {
      const vueThat = this
      vueThat.examine.type = 0
      vueThat.stepActive = 0
      vueThat.processStatus = 'finish'
    }
  }
}
</script>

<style>
</style>
